import useEvent from '@lyearn/core/hooks/useEvent';
import { ArrowIosRightOutline } from '@lyearn/icons';
import { Button, Stack, Typography, useSnackbar } from '@lyearn/ui';
import useNavigation from '@/hooks/useNavigation';
import useJobByCreatorSubscriptionFn from '@/modules/corporate/modules/bulk-import/hooks/useJobByCreatorSubscription';
import { getLanguageName } from '@/modules/corporate/modules/micro-learning/views/MicroLearningBuilder/components/LanguageSelector';
import routes from '@/pages/corporate/routes';
import { JobEntityStatusEnum, JobPurposeEnum, ResourceTypeEnum } from '@/types/schema';

import { ViewContentProps } from './types';

export default function ViewContent({
  t,
  languageConfig,
  allLanguagesMap,
  languageType,
  resourceType,
}: ViewContentProps) {
  const { showSnackbar } = useSnackbar();
  const onSuccess = useEvent(() => {
    showSnackbar({
      message: t('Course:CreateLocalizedContentSuccess', {
        language: getLanguageName(languageConfig.languageType),
      }),
    });
  });

  const { fetching: isFetchingJobByCreator } = useJobByCreatorSubscriptionFn({
    pause: languageConfig.jobStatus !== JobEntityStatusEnum.InProcess!,
    purpose: [JobPurposeEnum.AiBlockLocaleTranslation],
    onSuccess,
  });

  const navigation = useNavigation();
  const navigateToCourseBuilder = (resourceId: string) => {
    let route = routes.CourseBuilder(resourceId);
    switch (resourceType) {
      case ResourceTypeEnum.Quiz:
        route = routes.QuizEditor(resourceId);
        break;
      case ResourceTypeEnum.Article:
        route = routes.ArticleBuilder(resourceId);
        break;
      case ResourceTypeEnum.Path:
        route = routes.AdminPathDetails(resourceId);
        break;
      case ResourceTypeEnum.Survey:
        route = routes.AdminSurveyDetails(resourceId);
        break;
    }
    navigation.push(route, { appendQuery: false });
  };
  return (
    <Stack
      key={languageConfig.languageType}
      alignItems="center"
      className="mb-16 pl-8 pr-8"
      justifyContent="between">
      <Typography color="text-text-secondary" variant="body-short-02">
        {allLanguagesMap[languageConfig.languageType]}
      </Typography>
      <Button
        appearance="primary"
        className="rounded-4"
        disabled={languageType == languageConfig.languageType}
        loading={isFetchingJobByCreator}
        size="x-small"
        variant="ghost"
        onClick={() => navigateToCourseBuilder(languageConfig.contentId)}>
        <Typography className="mr-8" variant="body-short-02">
          {t('Common:ViewContent')}
        </Typography>
        <ArrowIosRightOutline />
      </Button>
    </Stack>
  );
}
